/**
 * Vuikit 0.8.10
 * (c) 2018 Miljan Aleksic
 * @license MIT
**/

/* Substantial part of the code is adapted from UIkit,
  Copyright (c) 2013-2018 YOOtheme GmbH, getuikit.com */

import { Drop } from './drop';

var dropdown = {
  name: 'VkDropdown',
  extends: Drop,
  props: {
    mainClass: {
      default: 'uk-dropdown'
    }
  }
}

export { dropdown as Dropdown };
